import React, { useState } from 'react'
import Modal from '../../common/modal'
import { Box, Stack } from '@mui/material'
import { connect } from 'react-redux'
import { updateModal } from '../../../store/common/common_action'
import { Item } from '../../common/snippets'
import SenderReceiverTab from './SendRecDetailChange'
import EwayBillTab from './EWayBillTab'
import BookingDeliveryTab from './BookingDeliveryTab'
import ConsignmentBookingCharge from './ConsignmentBookingCharge'
import { useTranslation } from '../../../i18n/I18nProvider'
import { getTabPopupHeadTxt } from './adminUpdateConstants'
//import VehicleDispatchTab from './VehicleDispatchTab'

const TabPopup = (props) => {
  const { updateModal, data } = { ...props }
  const { translations } = useTranslation()
  const [senderSectContent, setSenderSectContent] = useState(props.senderSectContent)
  const [selectLr, setSelectLr] = useState(props.lrDetail)
  return (
    <Modal
      headTxt={getTabPopupHeadTxt(translations, senderSectContent, props?.selectedRadio)}
      width={'95%'}
      updateModal={updateModal}
    >
      <Stack>
        <Item sx={{ width: '100%', margin: '0px', padding: '10px 0' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            {/* <Tabs value={senderSectContent} onChange={handleSenderSect} aria-label="bsic tabs example">
              {senderSect.map((reqType, index) => (
                <Tab key={`sender_${index}`} label={reqType} {...a11yProps(index)} />
              ))}
            </Tabs> */}
          </Box>
        </Item>
        {senderSectContent === 0 ? (
          <SenderReceiverTab selectLr={selectLr} updateData={props.updateData} setOnClosePopup={props.onClosePopup} />
        ) : (
          ''
        )}
        {senderSectContent === 1 ? <EwayBillTab selectLr={selectLr} setOnClosePopup={props.onClosePopup} /> : ''}
        {senderSectContent === 2 ? (
          props?.selectedRadio === 'modify' ? (
            <ConsignmentBookingCharge selectLr={selectLr} updateData={props.updateData} setOnClosePopup={props.onClosePopup} />
          ) : (
            <BookingDeliveryTab selectLr={selectLr} updateData={props.updateData} setOnClosePopup={props.onClosePopup}  />
          )
        ) : (
          ''
        )}
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(TabPopup)
